module.exports = __webpack_public_path__ + "img/hipercard.887b06e.png";